import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCardAltComponent } from '../product-card-alt/product-card-alt.component';
import { Sale } from '../../../shared/interfaces/sale';
import { Step } from '../../../shared/interfaces/step';
import { Cart } from '../../classes/cart';

@Component({
    selector: 'app-cart-list',
    standalone: true,
    imports: [CommonModule, ProductCardAltComponent],
    templateUrl: './cart-list.component.html',
    styleUrl: './cart-list.component.scss',
})
export class CartListComponent {
    @Input({ required: true }) public sale!: Sale;

    @Input({ required: true }) public steps!: Step[];

    public constructor(
        public readonly cart: Cart,
    ) {}
}
